/** Extrae mensaje legible desde respuestas de error de la API (axios). */
export const extractApiErrorMessage = (error: unknown, fallback: string): string => {
  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const err = error as { response?: { data?: unknown }; message?: string };
  const data = err.response?.data;

  if (data && typeof data === 'object') {
    const payload = data as Record<string, unknown>;

    const validationErrors = payload.errors;
    if (validationErrors && typeof validationErrors === 'object') {
      const messages = Object.values(validationErrors as Record<string, unknown>)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .filter((value): value is string => typeof value === 'string' && value.trim().length > 0);

      if (messages.length > 0) {
        return messages.join(' ');
      }
    }

    if (typeof payload.message === 'string' && payload.message.trim()) {
      return payload.message;
    }

    const nestedError = payload.error;
    if (nestedError && typeof nestedError === 'object') {
      const nestedMessage = (nestedError as { message?: string }).message;
      if (typeof nestedMessage === 'string' && nestedMessage.trim()) {
        return nestedMessage;
      }
    }

    if (typeof nestedError === 'string' && nestedError.trim()) {
      return nestedError;
    }
  }

  if (typeof err.message === 'string' && err.message.trim()) {
    return err.message;
  }

  return fallback;
};
